module.exports = __webpack_public_path__ + "static/media/selected_transitional_marker.4021a715.svg";